import { appleRedirectUri } from './config'

let state

export const UNKNOWN_ERROR = 0
export const INVALID_REQUEST = 1
export const USER_NOT_FOUND = 2
export const USER_CANCELLED = 3

function getSignInUrl() {
  state =
    new Date().getTime().toString() +
    Math.random()
      .toString(20)
      .substring(2)

  const url =
    'https://appleid.apple.com/auth/authorize?' +
    new URLSearchParams({
      response_type: 'id_token code',
      response_mode: 'form_post',
      client_id: 'signInWithApple.com.sillens.iShape',
      redirect_uri: appleRedirectUri,
      scope: 'name email',
      state,
    })
  return url
}

export function handleMessage(data, state) {
  if (!data || data.state !== state) {
    throw {
      code: INVALID_REQUEST,
      message: 'The response does not contain valid data',
    }
  }

  if (data.error) {
    throw {
      code: data.error.code,
      message: data.error.message,
    }
  }

  if (data.apple_uid) {
    return {
      apple_uid: data.apple_uid,
    }
  }

  throw {
    code: UNKNOWN_ERROR,
    message: 'Something went wrong',
  }
}

export function login() {
  return new Promise((resolve, reject) => {
    // Opening a blank page first prevents Apple’s custom
    // fingerprint overlay from breaking the flow.
    const appleWindow = window.open()

    const viewportMeta = document.createElement('meta')
    viewportMeta.name = 'viewport'
    viewportMeta.content =
      'width=device-width, initial-scale=1, viewport-fit=cover'
    appleWindow.document.head.appendChild(viewportMeta)

    const img = document.createElement('img')

    // Use URL() to get an absolute path to the image
    img.src = new URL(require('media/spinner.gif'), document.location)
    img.width = 44
    img.height = 44

    const div = document.createElement('div')
    div.style.display = 'flex'
    div.style.justifyContent = 'center'
    div.style.alignItems = 'center'
    div.style.height = '100vh'

    div.appendChild(img)
    appleWindow.document.body.appendChild(div)

    appleWindow.location = getSignInUrl()

    const windowClosedInterval = setInterval(() => {
      if (appleWindow.closed) {
        clearInterval(windowClosedInterval)
        reject({
          code: USER_CANCELLED,
          message: 'The user closed the popup',
        })
      }
    }, 500)

    window.addEventListener('message', e => {
      const { data, origin, source } = e

      if (!origin.endsWith('.lifesum.com')) return
      if (source !== appleWindow) return

      clearInterval(windowClosedInterval)
      appleWindow.close()

      try {
        const response = handleMessage(data, state)
        if (response) resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  })
}
